import React, { useEffect, useState } from "react";
import { fetchFeatured } from "../lib/api";
import { DateCard } from "./DateCard";
import { useReveal } from "../lib/useReveal";

export const FeaturedDates = ({ onOpenDetail }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const ref = useReveal();

  useEffect(() => {
    let alive = true;
    fetchFeatured()
      .then((data) => alive && setItems(data))
      .catch((e) => alive && setError(e?.message || "Could not load featured dates."))
      .finally(() => alive && setLoading(false));
    return () => { alive = false; };
  }, []);

  return (
    <section id="featured" className="section reveal" ref={ref} data-testid="featured-section">
      <div className="shell">
        <header style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", flexWrap: "wrap", gap: "1.5rem", marginBottom: "2.5rem" }}>
          <div>
            <span className="section__eyebrow">Featured Observances</span>
            <h2 style={{ marginTop: 0 }}>Dates that shaped the year — and the country.</h2>
          </div>
          <p className="section__lede" style={{ flex: "1 1 380px", maxWidth: 540 }}>
            A curated set of holidays, heritage months, and historic anniversaries that reflect the full sweep of who built and reshaped the United States.
          </p>
        </header>

        {error && (
          <div role="alert" style={{ padding: "1rem", border: "1px solid hsl(var(--line))", color: "hsl(var(--ink-soft))" }}>
            {error}
          </div>
        )}

        <div
          data-testid="featured-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "1.25rem",
          }}
        >
          {loading
            ? Array.from({ length: 8 }).map((_, i) => (
                <div key={i} style={{
                  height: 220,
                  background: "hsl(var(--bg-elev))",
                  border: "1px solid hsl(var(--line))",
                  opacity: 0.55,
                }} />
              ))
            : items.map((entry) => (
                <DateCard key={entry.id} entry={entry} onOpen={onOpenDetail} />
              ))}
        </div>
      </div>
    </section>
  );
};
